import axios from "axios";

import { API_USERS_ROBOTS } from "../../libs/constants";

import { getToken } from "../../libs/auth";

// ##############################
// For all of accessible Robots
// ##############################
export async function getRobots(payload) {
  const url = `${API_USERS_ROBOTS}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      // console.log("getRobots", data);
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getOperationHours(payload) {
  const url = `${API_USERS_ROBOTS}/operation_hours`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getPerformanceWeldHours(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/performance/weld_hours?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getPerformanceWeldInches(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/performance/weld_inches?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getPerformanceOperatorsWeldHours(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/performance/operators_weld_hours?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getPerformanceOperatorsWeldInches(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/performance/operators_weld_inches?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getPerformanceWithoutWeldHours(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/performance/inactive?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getStatisticsPipeSize(payload, query) {
  const queryParams = new URLSearchParams(query);
  const url = `${API_USERS_ROBOTS}/statistics/pipe_size?${queryParams.toString()}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

// ##############################
// For Individual Robot
// ##############################
export async function getProgramData(params, query) {
  const url = `${API_USERS_ROBOTS}/${params}/program_data?key=${query}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getWeldRuns(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/weld_run?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getRobotPerformanceWeldHours(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/performance/weld_hours?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
export async function getRobotPerformanceWeldInches(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/performance/weld_inches?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
export async function getRobotPerformanceOperatorsWeldHours(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/performance/operators_weld_hours?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
export async function getRobotPerformanceOperatorsWeldInches(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/performance/operators_weld_inches?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getTier(params) {
  const url = `${API_USERS_ROBOTS}/${params}/bandwidth`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function updateUsage(params, payload) {
  const url = `${API_USERS_ROBOTS}/${params}/bandwidth`;
  const options = {
    method: "put",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: payload,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getUsage(params, query) {
  const queryString = new URLSearchParams(query).toString();
  const url = `${API_USERS_ROBOTS}/${params}/bandwidth/usage?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getWeldTestReports(params, query) {
  const queryString = new URLSearchParams(query).toString();

  const url = `${API_USERS_ROBOTS}/${params}/weld_test_reports?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function createWeldTestReport(params, payload) {
  console.log(payload);
  const url = `${API_USERS_ROBOTS}/${params}/weld_test_reports`;
  const options = {
    method: "POST",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getWeldTestReport(params, query) {
  const queryString = new URLSearchParams(query).toString();

  const url = `${API_USERS_ROBOTS}/${params.robot_id}/weld_test_reports/${params.report_id}?${queryString}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function updateWeldTestReport(params, payload) {
  const url = `${API_USERS_ROBOTS}/${params.robot_id}/weld_test_reports/${params.report_id}`;
  const options = {
    method: "PUT",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function deleteWeldTestReport(params) {
  const url = `${API_USERS_ROBOTS}/${params.robot_id}/weld_test_reports/${params.report_id}`;
  const options = {
    method: "DELETE",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
